import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// PrimeNG
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import {CascadeSelectModule} from 'primeng/cascadeselect';
import {ListboxModule} from 'primeng/listbox';
import { TreeModule } from 'primeng/tree';
import { PasswordModule } from 'primeng/password';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';

// Utility Components.
import { AlertLineComponent } from './alert-line/alert-line.component';

// Utility modules.
import { ConstantsModule } from './constants/constants.module';

// Login pages.
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { HomeComponent } from './home/home.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

// Company handler pages.
import { CompanyAddComponent } from './company-add/company-add.component';
import { CompanyListComponent } from './company-list/company-list.component';
import { CompanyEditComponent } from './company-edit/company-edit.component';
import { CompanyDetailComponent } from './company-detail/company-detail.component';

// User handler pages.
import { UserListComponent } from './user-list/user-list.component';
import { UserAddComponent } from './user-add/user-add.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UserDetailComponent } from './user-detail/user-detail.component';

// Folder handler pages.
import { FolderListComponent } from './folder-list/folder-list.component';
import { FolderAddComponent } from './folder-add/folder-add.component';
import { FolderEditComponent } from './folder-edit/folder-edit.component';
import { FolderDetailComponent } from './folder-detail/folder-detail.component';
import { FolderEditRightsComponent } from './folder-edit-rights/folder-edit-rights.component';

// Account handler pages.
import { MyAccountComponent } from './my-account/my-account.component';
import { MyPasswordComponent } from './my-password/my-password.component';
import { FolderDetailAdminComponent } from './folder-detail-admin/folder-detail-admin.component';
import { FolderEditMailComponent } from './folder-edit-mail/folder-edit-mail.component';
import { FolderReminderComponent } from './folder-reminder/folder-reminder.component';
import { UserAddMinicompanyComponent } from './user-add-minicompany/user-add-minicompany.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { InfosComponent } from './infos/infos.component';
import { FolderUpdaterComponent } from './folder-updater/folder-updater.component';
import { FolderRestartComponent } from './folder-restart/folder-restart.component';
import { UserGenerateNewPasswordComponent } from './user-generate-new-password/user-generate-new-password.component';

@NgModule({
  declarations: [
    AppComponent,

    // Login pages.
    LoginComponent,
    LogoutComponent,
    HomeComponent,
    ResetPasswordComponent,

    // Companies.
    CompanyAddComponent,
    CompanyDetailComponent,
    CompanyListComponent,
    CompanyEditComponent,

    // Users.
    UserListComponent,
    UserAddComponent,
    UserEditComponent,
    UserDetailComponent,
    UserAddMinicompanyComponent,
    UserGenerateNewPasswordComponent,

    // Folders.
    FolderListComponent,
    FolderAddComponent,
    FolderEditComponent,
    FolderDetailComponent,
    FolderEditRightsComponent,
    FolderUpdaterComponent,
    FolderRestartComponent,
    FolderDetailAdminComponent,
    FolderEditMailComponent,
    FolderReminderComponent,

    // Files.
    FileUploadComponent,

    // Account.
    MyAccountComponent,
    MyPasswordComponent,

    // Composants utilitaires.
    AlertLineComponent,

    // Divers
    InfosComponent,
    
  ],
  imports: [
    // External injection.
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		AppRoutingModule,
		FormsModule,
		ReactiveFormsModule,
		NgbModule,
		MatTooltipModule,

    // PrimeNG
		ButtonModule,
		DropdownModule,
		InputTextModule,
		TableModule,
		CascadeSelectModule,
		ListboxModule,
		TreeModule,
		PasswordModule,
		EditorModule,
		FileUploadModule,
    MultiSelectModule,

		// Utility injection.

		// Constants injection.
		ConstantsModule,
  ],
  providers: [
    AlertLineComponent,
	  CookieService,
    NgbActiveModal
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
